export const BUSINESS = {
  name: "FASTag CSP Sayeed Anwar Bally",
  shortName: "FASTag CSP",
  tagline: "Your Trusted Partner for FASTag Solutions",
  owner: "Sayeed Anwar",
  phone: "7603099563",
  phoneDisplay: "+91 76030 99563",
  email: "Fastagcsp@gmail.com",
  whatsapp: "917603099563",
  address: "Toll Plaza, Rajchandrapur, Bally, Howrah, West Bengal 711205",
  addressShort: "Bally Toll Plaza, Howrah, WB 711205",
  hours: [
    { day: "Mon – Sat", time: "10:00 AM – 8:00 PM" },
    { day: "Sunday", time: "10:00 AM – 2:00 PM" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=FASTAG+CSP+BALLY+TOLL&ll=22.6550853,88.3247488&z=17&output=embed",
  mapsLink:
    "https://maps.app.goo.gl/68s13xTjNpwYwpTH8",
  reviewsLink:
    "https://search.google.com/local/reviews?placeid=&ludocid=3073995705981662906",
  writeReviewLink:
    "https://search.google.com/local/writereview?placeid=&ludocid=3073995705981662906",
  directionsLink:
    "https://www.google.com/maps/dir/?api=1&destination=22.6550853,88.3247488&destination_place_id=FASTAG+CSP+BALLY+TOLL",
  coords: { lat: 22.6550853, lng: 88.3247488 },
};

export const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/0m604f44_Fastag%20CSP%20Bally%20Logo%20pro.png";

export const BANKS = [
  "IDFC First Bank", "ICICI Bank", "SBI FASTag", "Bajaj Pay FASTag",
  "Airtel Payments Bank", "Kotak Mahindra Bank", "HDFC Bank", "Axis Bank",
  "IDBI Bank", "Paytm Payments Bank", "AU Small Finance Bank", "Yes Bank",
];

// Featured bank partners with logos (Google favicon service — reliable & fast)
export const BANK_PARTNERS = [
  { name: "ICICI Bank",            short: "ICICI",       domain: "icicibank.com" },
  { name: "IDFC First Bank",       short: "IDFC FIRST",  domain: "idfcfirstbank.com" },
  { name: "Airtel Payments Bank",  short: "Airtel",      domain: "airtel.in" },
  { name: "Bajaj Pay FASTag",      short: "Bajaj Pay",   domain: "bajajfinserv.in" },
  { name: "Kotak Bank FASTag",     short: "Kotak",       domain: "kotakbank.com" },
  { name: "SBI FASTag",            short: "SBI",         domain: "sbicard.com" },
].map(b => ({ ...b, logo: `https://www.google.com/s2/favicons?sz=128&domain=${b.domain}` }));

export const HERO_SLIDES = [
  {
    tag: "Instant Activation",
    title: "New FASTag in Just 15 Minutes",
    subtitle:
      "Buy a new FASTag today — instant issuance, secure payments, and hassle-free travel at all toll plazas across India.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/duztxbrx_Fastag%20banner%202.png",
    ctaLabel: "Buy New FASTag",
    ctaTo: "/order?service=New%20FASTag",
  },
  {
    tag: "Blacklist / Hotlist Removal",
    title: "FASTag Blacklisted or Hotlisted?",
    subtitle:
      "We resolve blacklist, hotlist, low balance and KYC issues quickly across all major banks — travel smooth again.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/ub1m1ubu_Fastag%20banner%201.png",
    ctaLabel: "Fix My FASTag",
    ctaTo: "/order?service=FASTag%20Replacement",
  },
  {
    tag: "Blacklist Resolution",
    title: "Instant Solution for All Major Banks",
    subtitle:
      "Facing FASTag blacklist or hotlist issue? Our team provides instant resolution — 100% secure and reliable.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/ezcwtea4_Fastag%20Banner%204.png",
    ctaLabel: "Get Support",
    ctaTo: "/contact",
  },
  {
    tag: "Our Team",
    title: "Trusted Service Across India",
    subtitle:
      "Meet the FASTag CSP Sayeed Anwar Bally team — dedicated professionals delivering instant activation and 24/7 support.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/hyw4emyv_fastag%20csp%20team.png",
    ctaLabel: "Meet the Team",
    ctaTo: "/about",
  },
  {
    tag: "Statewide Delivery",
    title: "FASTag Delivered Across West Bengal",
    subtitle:
      "Order online — we coordinate delivery to all 23 districts of West Bengal, Kolkata, Howrah, Siliguri and beyond.",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/ub1m1ubu_Fastag%20banner%201.png",
    ctaLabel: "Order Now",
    ctaTo: "/order",
  },
];

export const SERVICES = [
  {
    key: "new",
    title: "New FASTag Issuance",
    desc: "Buy a new FASTag with instant 15-minute activation. Guidance on RC, KYC and vehicle documents included.",
    icon: "Sparkles",
  },
  {
    key: "activation",
    title: "Instant FASTag Activation",
    desc: "Get your unactivated FASTag mapped to your vehicle and ready for toll use within minutes.",
    icon: "Zap",
  },
  {
    key: "recharge",
    title: "Instant Recharge",
    desc: "Top-up your FASTag balance instantly with UPI/card assistance at our counter — all major banks supported.",
    icon: "Wallet",
  },
  {
    key: "blacklist",
    title: "Blacklist / Hotlist Removal",
    desc: "Facing FASTag blacklist or hotlist issue? We provide instant resolution across all major banks.",
    icon: "ShieldAlert",
  },
  {
    key: "kyc",
    title: "KYC & Technical Issues",
    desc: "Low balance, KYC pending or technical errors? Our expert team fixes it fast — 100% safe and secure.",
    icon: "FileCheck",
  },
  {
    key: "replacement",
    title: "Replacement & Reissue",
    desc: "Damaged, expired or lost FASTag? We help you get a fresh tag issued with minimal paperwork.",
    icon: "RefreshCcw",
  },
  {
    key: "commercial",
    title: "Commercial Vehicle Tags",
    desc: "Bulk issuance for trucks, buses, LCVs, taxis and fleet operators — dedicated onboarding support.",
    icon: "Truck",
  },
  {
    key: "csp",
    title: "CSP & Digital Services",
    desc: "Selected banking CSP assistance and digital payment help alongside FASTag services.",
    icon: "Landmark",
  },
];

export const WHY_US = [
  { title: "Toll-Plaza Location", desc: "Right next to Bally Toll Plaza — easy to spot, easy to reach.", icon: "MapPin" },
  { title: "In-Person Support", desc: "Talk to a real person; we walk you through every document.", icon: "HeartHandshake" },
  { title: "Fast Turnaround", desc: "Most FASTag issuance completed the same day at our counter.", icon: "Timer" },
  { title: "Multi-Bank Assistance", desc: "Guidance across popular FASTag issuing banks in India.", icon: "Building2" },
  { title: "Statewide Delivery", desc: "Doorstep delivery coordinated across all 23 WB districts.", icon: "PackageCheck" },
  { title: "Call & WhatsApp Support", desc: "Reach us on phone or WhatsApp for any follow-up.", icon: "MessageCircle" },
];

export const STEPS = [
  { n: "01", title: "Share Your Details", desc: "Fill the order form or WhatsApp your vehicle & KYC details.", icon: "PenLine" },
  { n: "02", title: "We Verify & Process", desc: "We verify documents, initiate issuance and confirm delivery.", icon: "ShieldCheck" },
  { n: "03", title: "Receive & Ride", desc: "Get your activated FASTag at our counter or delivered to you.", icon: "Rocket" },
];

export const GALLERY = [
  "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/hyw4emyv_fastag%20csp%20team.png",
  "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/ub1m1ubu_Fastag%20banner%201.png",
  "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/duztxbrx_Fastag%20banner%202.png",
  "https://customer-assets-cm19k8pv.emergentagent.net/job_toll-service-hub/artifacts/ezcwtea4_Fastag%20Banner%204.png",
  "https://images.pexels.com/photos/9779281/pexels-photo-9779281.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/16577201/pexels-photo-16577201.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/7946957/pexels-photo-7946957.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.pexels.com/photos/7681369/pexels-photo-7681369.jpeg?auto=compress&cs=tinysrgb&w=800",
];

export const FAQS = [
  {
    q: "What documents are required for a new FASTag?",
    a: "Typically Vehicle RC, KYC of the vehicle owner (Aadhaar/PAN/passport/driving licence/voter ID) and a photo of the vehicle with the number plate visible. Requirements can vary slightly by issuing bank.",
  },
  {
    q: "How long does FASTag activation take?",
    a: "In most cases activation is completed within a few hours to 24 hours after successful KYC verification by the issuing bank.",
  },
  {
    q: "Can I recharge my FASTag at your counter?",
    a: "Yes, we assist with recharges via UPI/card and can guide you through the app-based flow for your issuing bank.",
  },
  {
    q: "Do you assist commercial vehicles and fleet operators?",
    a: "Yes. We support trucks (2/3-axle), buses, LCVs, taxis and fleets. Contact us for bulk vehicle onboarding.",
  },
  {
    q: "Do you deliver FASTags outside Howrah?",
    a: "Yes — we coordinate delivery across all 23 districts of West Bengal. Delivery timelines depend on your location and courier availability.",
  },
  {
    q: "What are your opening hours?",
    a: "Monday to Saturday: 10:00 AM – 8:00 PM. Sunday: 10:00 AM – 2:00 PM.",
  },
];

export const WB_DISTRICTS = [
  "Alipurduar", "Bankura", "Birbhum", "Cooch Behar", "Dakshin Dinajpur",
  "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Jhargram",
  "Kalimpong", "Kolkata", "Malda", "Murshidabad", "Nadia",
  "North 24 Parganas", "Paschim Bardhaman", "Paschim Medinipur",
  "Purba Bardhaman", "Purba Medinipur", "Purulia", "South 24 Parganas",
  "Uttar Dinajpur",
];

export const VEHICLE_TYPES = [
  "Car / SUV", "LCV", "Truck (2-Axle)", "Truck (3-Axle)", "Bus", "Tractor", "Other",
];

export const SERVICE_TYPES = [
  "New FASTag", "FASTag Recharge", "FASTag Activation", "FASTag Replacement", "Other Assistance",
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/order", label: "Order FASTag" },
  { to: "/gallery", label: "Gallery" },
  { to: "/reviews", label: "Reviews" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
